/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { futuresGetLongTermForecast } from "../../funcs/futuresGetLongTermForecast.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetLongTermForecastRequest$inboundSchema,
};

export const tool$futuresGetLongTermForecast: ToolDefinition<typeof args> = {
  name: "futures-get-long-term-forecast",
  description: `Get long-term forecast for a future

Returns a list of booleans indicating whether the price of the given future is expected to increase over the next 12 months.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await futuresGetLongTermForecast(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
